(function() {
    'use strict';

    a3_cabin_reports.controller('AbsentTraineesModalCtrl', AbsentTraineesModalCtrl)
    /**
     * @memberof CabinReports
     * @ngdoc controller
     * @name AbsentTraineesModalCtrl
     * @description 
     * Show absent trainee(s) modal
     * @ngInject
     */

    function AbsentTraineesModalCtrl($scope, $uibModalInstance, absentTrainees){
        $scope.cancel = cancel;
        $scope.confirm = confirm;
        $scope.absentTrainees = absentTrainees;

        /**
         * Close the modal
         * @memberof AbsentTraineesModalCtrl
         */
        function cancel(){
            $uibModalInstance.close();
        }

        function confirm(){
            $uibModalInstance.close('confirmed');
        }
    }
})();